<template>
     <vs-popup :active.sync="isActive" :title="theReport.dateString+' Gün Sonu Raporu ' + theReport.branchName"  v-esc="escape" id="billReviewerPopup">
      <div class="con-example-prompt" v-if="theReport != null" id="popupcontent">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12" id="billHeader" vs-justify="space-between">
            <vs-col vs-type="flex" vs-w="6" class="pl-5 py-5">
              <vs-row vs-type="flex" vs-w="12">
                <vs-row vs-type="flex" vs-w="12" vs-align="center">
                  <span class="text-primary bold h4">
                    {{theReport.branchName}}
                  </span>
                  <span class="text-primary bold h4" style="margin-left: 10px;">
                    GÜN SONU RAPORU
                  </span>
                  <vx-tooltip v-if="!isPrintMode" text="Yazdır" position="top">
                    <vs-button @click="printReport" color="primary" size="small" class="ml-2" icon-pack="feather"
                      icon="icon-printer" />
                  </vx-tooltip>

                   <vx-tooltip title="Excel Export"
                    position="top">
                    <vs-button @click="getExcel" color="primary" type="gradient" size="small"
                      class="ml-2" icon-pack="feather" icon="icon-download" />
                  </vx-tooltip>
                </vs-row>
                <vs-row vs-type="flex" vs-w="12" class="mt-1">
                  <span class="h5 w-full">
                    {{theReport.dateString}} Yetkili: {{ theReport.userName }}
                  </span>
                </vs-row>
              </vs-row>
            </vs-col>
            <vs-col vs-type="flex" vs-w="5" class="mr-2" id="bill-logo-col" vs-justify="flex-end">
              <img :src= logo id="bill-logo" />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" id="billContent">
            <table id="myTable">
  <thead>
    <tr>
      <th>Tür</th>
      <th>Rapor</th>
      <th>Sistem</th>
      <th>Fark</th>
      <!-- Add more column headers if needed -->
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Kasa Sayım Tutarı</td>
      <td>{{ formatMoney(theReport.instantCashBalance) }}</td>
      <td>{{ formatMoney(theReport.openCountingAmount+theReport.totalCashGiro - theReport.totalExpense + theReport.totalSafeCashEntriesPrice) }}</td>
      <td>
        <span :class="{
          'text':theReport.cashDifference ==0,
          'text-success': theReport.cashDifference > 0,
          'text-danger': theReport.cashDifference < 0
        }">{{ formatSignedMoney(theReport.cashDifference) }}</span>
        </td>
      <!-- Add more cells for each row if needed -->
    </tr>
    <tr>
      <td>Açılış Tutarı-Dünden Devir</td>
      <td>{{ formatMoney(theReport.openCountingAmount) }}</td>
      <td>{{ formatMoney(theReport.openTransferredAmount) }}</td>
      <td>
        <span :class="{
          'text':theReport.dayOpenSummary ==0,
          'text-success': theReport.dayOpenSummary > 0,
          'text-danger': theReport.dayOpenSummary < 0
        }">{{ formatSignedMoney(theReport.dayOpenSummary) }}</span>
        </td>
    </tr>
    <tr>
      <td>Kasa Gider Toplamı</td>
      <td></td>
      <td>{{ formatMoney(theReport.totalExpense) }}</td>
      <td></td>
    </tr>
    <tr>
      <td>Kasa Giriş Toplamı</td>
      <td></td>
      <td>{{ formatMoney(theReport.totalSafeCashEntriesPrice) }}</td>
      <td></td>
    </tr>
    <tr>
      <td>Ertesi Güne Devredilecek Tutar</td>
      <td></td>
      <td>{{ formatMoney(theReport.nextDayCash) }}</td>
      <td></td>
    </tr>
    <!-- Add more rows with data if needed -->
  </tbody>
</table>

<table id="myTable">
  <thead>
    <tr><th colspan="4" style="text-align: center;">CİRO HESAPLAMALARI</th></tr>
    <tr>
      <th>Tür</th>
      <th>Rapor</th>
      <th>Sistem</th>
      <th>Fark</th>
      <!-- Add more column headers if needed -->
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Nakit</td>
      <td>{{ formatMoney(theReport.instantCashBalance +theReport.totalExpense - theReport.openCountingAmount - theReport.totalSafeCashEntriesPrice) }}</td>
      <td>{{ formatMoney(theReport.totalCashGiro) }}</td>
      <td>
        <span :class="{
          'text':cashGiroDifference ==0,
          'text-success': cashGiroDifference > 0,
          'text-danger': cashGiroDifference < 0
        }">{{ formatSignedMoney(cashGiroDifference) }}</span>
      </td>
    </tr>
    <tr>
      <td>Kredi Kartı</td>
      <td>{{ formatMoney(theReport.zReportForCard) }}</td>
      <td>{{ formatMoney(theReport.totalCardGiro) }}</td>
      <td>
        <span :class="{
          'text':cardGiroDifference ==0,
          'text-success': cardGiroDifference > 0,
          'text-danger': cardGiroDifference < 0
        }">{{ formatSignedMoney(cardGiroDifference) }}</span>
      </td>
    </tr>
    <tr>
      <td>Diğer</td>
      <td>{{ formatMoney(otherReportTotal) }}</td>
      <td>{{ formatMoney(otherSystemTotal) }}</td>
      <td>
        <span :class="{
          'text':otherDifference ==0,
          'text-success': otherDifference > 0,
          'text-danger': otherDifference < 0
        }">{{ formatSignedMoney(otherDifference) }}</span>
      </td>
    </tr>
    <tr>
      <td>Cüzdan</td>
      <td>-</td>
      <td>{{ formatMoney(theReport.walletReport) }}</td>
      <td>{{ formatMoney(0) }}</td>
    </tr>
    <tr>
      <td>Toplam</td>
      <td>{{ formatMoney(theReport.totalGiroReport) }}</td>
      <td>{{ formatMoney(theReport.totalGiro) }}</td>
      <td>
        <span :class="{
          'text':totalGiroDiffrence ==0,
          'text-success': totalGiroDiffrence > 0,
          'text-danger': totalGiroDiffrence < 0
        }">{{ formatSignedMoney(totalGiroDiffrence) }}</span>
      </td>
    </tr>
  </tbody>
</table>
<table id="myTable">
<thead>
  <tr><th colspan="4" style="text-align: center;">DİĞER DETAY</th></tr>
    <tr>
      <th>Tür</th>
      <th>Rapor</th>
      <th>Sistem</th>
      <th>Fark</th>
      <!-- Add more column headers if needed -->
    </tr>
</thead>
<tbody>
  <tr>
    <td>Multinet</td>
    <td>{{ formatMoney(theReport.multinetReport) }}</td>
    <td>{{ formatMoney(theReport.multinetGiro) }}</td>
    <td>
        <span :class="{
          'text':multinetDifference ==0,
          'text-success': multinetDifference > 0,
          'text-danger': multinetDifference < 0
        }">{{ formatSignedMoney(multinetDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>Sodexo/Pluxee</td>
    <td>{{ formatMoney(theReport.sodexoReport) }}</td>
    <td>{{ formatMoney(theReport.sodexoGiro) }}</td>
    <td>
        <span :class="{
          'text':sodexoDifference ==0,
          'text-success': sodexoDifference > 0,
          'text-danger': sodexoDifference < 0
        }">{{ formatSignedMoney(sodexoDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>Ticket</td>
    <td>{{ formatMoney(theReport.ticketReport) }}</td>
    <td>{{ formatMoney(theReport.ticketGiro) }}</td>
    <td>
        <span :class="{
          'text':ticketDifference ==0,
          'text-success': ticketDifference > 0,
          'text-danger': ticketDifference < 0
        }">{{ formatSignedMoney(ticketDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>SetCard</td>
    <td>{{ formatMoney(theReport.setcardReport) }}</td>
    <td>{{ formatMoney(theReport.setcardGiro) }}</td>
    <td>
        <span :class="{
          'text':setcardDifference ==0,
          'text-success': setcardDifference > 0,
          'text-danger': setcardDifference < 0
        }">{{ formatSignedMoney(setcardDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>Metropol</td>
    <td>{{ formatMoney(theReport.metropolReport) }}</td>
    <td>{{ formatMoney(theReport.metropolGiro) }}</td>
    <td>
        <span :class="{
          'text':metropolDifference ==0,
          'text-success': metropolDifference > 0,
          'text-danger': metropolDifference < 0
        }">{{ formatSignedMoney(metropolDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>Tokenflex</td>
    <td>{{ formatMoney(theReport.tokenflexReport) }}</td>
    <td>{{ formatMoney(theReport.tokenflexGiro) }}</td>
    <td>
        <span :class="{
          'text':tokenflexDifference ==0,
          'text-success': tokenflexDifference > 0,
          'text-danger': tokenflexDifference < 0
        }">{{ formatSignedMoney(tokenflexDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>Getir</td>
    <td>{{ formatMoney(theReport.getirReport) }}</td>
    <td>{{ formatMoney(theReport.getirGiro) }}</td>
    <td>
        <span :class="{
          'text':getirDifference ==0,
          'text-success': getirDifference > 0,
          'text-danger': getirDifference < 0
        }">{{ formatSignedMoney(getirDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>Yemeksepeti</td>
    <td>{{ formatMoney(theReport.yemekSepetiReport) }}</td>
    <td>{{ formatMoney(theReport.yemekSepetiGiro) }}</td>
    <td>
        <span :class="{
          'text':yemekSepetiDifference ==0,
          'text-success': yemekSepetiDifference > 0,
          'text-danger': yemekSepetiDifference < 0
        }">{{ formatSignedMoney(yemekSepetiDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>Trendyol Yemek</td>
    <td>{{ formatMoney(theReport.trendyolReport) }}</td>
    <td>{{ formatMoney(theReport.trendyolGiro) }}</td>
    <td>
        <span :class="{
          'text':trendyolDifference ==0,
          'text-success': trendyolDifference > 0,
          'text-danger': trendyolDifference < 0
        }">{{ formatSignedMoney(trendyolDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>Migros Yemek</td>
    <td>{{ formatMoney(theReport.migrosReport) }}</td>
    <td>{{ formatMoney(theReport.migrosGiro) }}</td>
    <td>
        <span :class="{
          'text':migrosDifference ==0,
          'text-success': migrosDifference > 0,
          'text-danger': migrosDifference < 0
        }">{{ formatSignedMoney(migrosDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>iWallet</td>
    <td>{{ formatMoney(theReport.iWalletReport) }}</td>
    <td>{{ formatMoney(theReport.iWalletGiro) }}</td>
    <td>
        <span :class="{
          'text':iWalletDifference ==0,
          'text-success': iWalletDifference > 0,
          'text-danger': iWalletDifference < 0
        }">{{ formatSignedMoney(iWalletDifference) }}</span>
      </td>
  </tr>
  <tr>
    <td>Paye</td>
    <td>{{ formatMoney(theReport.payeReport) }}</td>
    <td>{{ formatMoney(theReport.payeGiro) }}</td>
    <td>
        <span :class="{
          'text':payeDifference ==0,
          'text-success': payeDifference > 0,
          'text-danger': payeDifference < 0
        }">{{ formatSignedMoney(payeDifference) }}</span>
      </td>
  </tr>
</tbody>
</table>
<table id="myTable">
  <thead>
    <tr>
      <th colspan="3" style="text-align: center;">KASA NAKİT ÇIKIŞLAR</th>
    </tr>
    <tr>
      <th>Tür</th>
      <th>Tutar</th>
      <th>Açıklama</th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="expense in theReport.expenses">
          <td>{{ expense.expenseDefinition.name }}</td>
          <td>{{ expense.price != null ? formatMoney(expense.price) : '' }}</td>
          <td>{{ expense.description }}</td>
        </tr>
      </tbody>
</table>
<table id="myTable">
  <thead>
    <tr>
      <th colspan="3" style="text-align: center;">KASA NAKİT GİRİŞLER</th>
    </tr>
    <tr>
      <th>Kullanıcı</th>
      <th>Tutar</th>
      <th>Açıklama</th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="entry in theReport.safeCashEntryDtos">
          <td>{{ entry.userName }}</td>
          <td>{{ entry.price != null ? formatMoney(entry.price) : '' }}</td>
          <td>{{ entry.description }}</td>
        </tr>
      </tbody>
</table>
          </vs-row>

          <vs-row vs-type="flex" vs-w="12" id="billFooter" class="px-6 py-4" vs-justify="flex-end">
            <table id="myTable" v-if="theReport.zReportImage">
  <thead>
    <tr>
      <th colspan="3" style="text-align: center;">Z Raporu Fotoğrafı</th>
    </tr>
  </thead>
</table>
            <img v-if="theReport.zReportImage" :src="$baseUrl + '/' + theReport.zReportImage" alt="img" class="responsive">
          </vs-row>
        </vs-row>
      </div>
    </vs-popup>
  </template>

  <script>
   import { GetExcel } from "@/api/DayOpen";
  import companyInfo from '../../../../model/constants/companyInfo';
    export default {
      data() {
        return {
          isPrintMode: false,
          isActive: false,
          theReport: null,
          logo:companyInfo.logo,

        }
      },
      components: {

      },
      methods: {
        formatMoney(value) {
          const amount = Number(value);
          if (isNaN(amount)) return '';
          return this.$toCurrency(amount);
        },
        formatSignedMoney(value) {
          const amount = Number(value);
          if (isNaN(amount)) return '';
          return (amount > 0 ? '+' : '') + this.$toCurrency(amount);
        },

        printReport() {
          this.isPrintMode = true;
          this.$nextTick(() => {
    //         var printContents = document.getElementById("popupcontent").innerHTML;
    //  var originalContents = document.body.innerHTML;

    //  document.body.innerHTML = printContents;

    //  window.print();

    //  document.body.innerHTML = originalContents;
    // Get HTML to print from element
const prtHtml = document.getElementById('popupcontent').innerHTML;

// Get all stylesheets HTML
let stylesHtml = '';
for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
  stylesHtml += node.outerHTML;
}

// Open the print window
const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

WinPrint.document.close();
window.setTimeout(() => {WinPrint.focus(); WinPrint.print(); WinPrint.close();  this.isPrintMode = false;}, 2000)
            this.isPrintMode = false;
           // window.location.reload();
          });
        },
        getExcel() {
          GetExcel(this.theReport.id).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Gün Sonu Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
        escape() {
          if (this.isActive == true) this.isActive = false;
        },

      },
      computed:{
        cashGiroDifference:{
          get(){
            return (this.theReport.instantCashBalance +this.theReport.totalExpense - this.theReport.openCountingAmount)-
            this.theReport.totalCashGiro - this.theReport.totalSafeCashEntriesPrice;
          }
        },
        cardGiroDifference:{
          get(){
            return  this.theReport.zReportForCard - this.theReport.totalCardGiro;
          }
        },
        otherReportTotal:{
          get(){
            return this.theReport.trendyolReport + this.theReport.yemekSepetiReport +this.theReport.getirReport +
            this.theReport.tokenflexReport +this.theReport.metropolReport +this.theReport.setcardReport
            +this.theReport.ticketReport +this.theReport.sodexoReport +this.theReport.multinetReport
            +this.theReport.migrosReport +this.theReport.iWalletReport +this.theReport.payeReport
          }
        },
        otherSystemTotal:{
          get(){
            return this.theReport.trendyolGiro + this.theReport.yemekSepetiGiro +this.theReport.getirGiro +
            this.theReport.tokenflexGiro +this.theReport.metropolGiro +this.theReport.setcardGiro
            +this.theReport.ticketGiro +this.theReport.sodexoGiro +this.theReport.multinetGiro
            +this.theReport.migrosGiro +this.theReport.iWalletGiro +this.theReport.payeGiro
          }
        },
        otherDifference:{
          get(){
            return this.otherReportTotal - this.otherSystemTotal;
          }
        },
        totalGiroDiffrence:{
          get(){
            return this.theReport.totalGiroReport - this.theReport.totalGiro;
          }
        },
        multinetDifference:{
          get(){
            return this.theReport.multinetReport - this.theReport.multinetGiro
          }
        },
        sodexoDifference:{
          get(){
            return this.theReport.sodexoReport - this.theReport.sodexoGiro
          }
        },
        ticketDifference:{
          get(){
            return this.theReport.ticketReport - this.theReport.ticketGiro
          }
        },
        setcardDifference:{
          get(){
            return this.theReport.setcardReport - this.theReport.setcardGiro
          }
        },
        metropolDifference:{
          get(){
            return this.theReport.metropolReport - this.theReport.metropolGiro
          }
        },
        tokenflexDifference:{
          get(){
            return this.theReport.tokenflexReport - this.theReport.tokenflexGiro
          }
        },
        getirDifference:{
          get(){
            return this.theReport.getirReport - this.theReport.getirGiro
          }
        },
        iWalletDifference:{
          get(){
            return this.theReport.iWalletReport - this.theReport.iWalletGiro
          }
        },
        payeDifference:{
          get(){
            return this.theReport.payeReport - this.theReport.payeGiro
          }
        },
        yemekSepetiDifference:{
          get(){
            return this.theReport.yemekSepetiReport - this.theReport.yemekSepetiGiro
          }
        },
        trendyolDifference:{
          get(){
            return this.theReport.trendyolReport - this.theReport.trendyolGiro
          }
        },
        migrosDifference:{
          get(){
            return this.theReport.migrosReport - this.theReport.migrosGiro
          }
        }
      }
    }

  </script>

  <style>
    #billReviewerPopup .vs-popup {
      width: 750px !important;
      color: #2B2B2B;
    }

    #billReviewerPopup .vs-popup .vs-popup--content {
      padding: 0 !important;
      margin: 0 !important;
      width: 100% !important;
      background: transparent linear-gradient(152deg, #F8F8F8 0%, #F1F1F1 100%) 0% 0% no-repeat padding-box;
    }

    #newBillTotalDiscountType,
    #entryDiscountType {
      min-width: 50px !important;
      background: rgba(var(--vs-primary), 1)
    }

    #bill-logo {
      filter: grayscale(100%);
      opacity: .08;
      height: 175%;
      margin-top: -18px;
    }

    #billHeader {
      height: 6rem;
      background: transparent linear-gradient(117deg, #F8F8F8 0%, #EFEFEF 100%) 0% 0% no-repeat padding-box;
      box-shadow: 0px 2px 4px #00000026;
      border-radius: 7px;
    }

    #bill-logo-col {
      height: 100%;
      overflow: hidden;
    }

    #billContentHeaderRow {
      padding-left: 1.75rem;
      padding-right: 1.75rem;
    }

    #billReviewerPopup .vs-popup .vs-popup--header {
      background: unset !important;
      box-shadow: 0px 2px 4px #00000026;
      border-radius: 7px 7px 0px 0px;
    }

    #billReviewerPopupList {
      height: 50vh;
      overflow-x: auto;
      box-shadow: 0px 2px 4px #00000026;
      border-radius: 7px;
    }

    #billContentEntry .vs-row .vs-list--item .list-titles .vs-list--subtitle {
      margin-left: 10px;
      font-weight: 500;
    }

    #billContentFooter {
      position: absolute;
      bottom: 0;
      right: 5%;
    }

    #billFooter .vs-inputx {
      border: none !important;
      border-bottom: 1px solid #00000035 !important;
      border-radius: 0;
      font-size: 12px;
    }

    #billFooter .vs__dropdown-toggle {
      border: none;
      border-bottom: 1px solid #00000035;
      border-radius: 0;
      font-size: 12px;
    }
    #myTable {
    border-collapse: collapse;
    width: 100%;
  }
  #myTable th, #myTable td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
  }
  #myTable th {
    background-color: #f2f2f2;
  }
  @media print {
  body * {
    visibility: visible !important;
    zoom:97%;
  }
}
  </style>
